module.exports = __webpack_public_path__ + "media/bootstrap-icons/play-b2d5dd15.svg";